export const environment = {
  production: false,
  host: 'https://api-stage.planetheroes.pl',
  client: 'https://stage.planetheroes.pl',
  FACEBOOK_APP_ID: '944070932695902',
  googleMapsApiKey: 'AIzaSyAPacAlx_iDTshNwyR0WqTgPfr0c6j-2tk',
  googleMapsHomepageId: 'c90aed99552ef6a9',
  sentry_dsn:
    'https://e130a40414cf09f943651bd90042ca09@o4505922875752448.ingest.us.sentry.io/4508886118432768',
};
